import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./lesson-modal.page.html",
  styleUrls: ["./lesson-modal.page.scss"],
})
export class LessonModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  lessonList: any;
  lessonSelectedList: any;
  trainingQualificationLessonList: any;
  loadingDone: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global
  ) {}

  ngOnInit() {
    // this.callingFilter = this.navParams.data.paramObject.callingFilter;
    // this.User_GUID = this.navParams.data.paramObject.User_GUID;
    // this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;

    this.GetLessonList();
  }

  async onLessonSelect(event: any, lesson: any) {
    await this.modalCtrl.dismiss(lesson);
  }

  GetLessonList() {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("Lesson_GUID_To_End", null);

    this.appservice.GetTrainingQualificationList(formData).subscribe((res) => {
      try {
        var result = JSON.parse(res.toString());

        this.lessonList = result.UserLessonTraining;
        // if(this.trainingQualificationList.length > 0)
        // {
        //   this.showQualificationList = true;
        // }else{
        //   this.showQualificationList = false;
        // }
        // this.trainingLessonList = this.trainingQualificationLessonList.UserLessonTraining;
        // if(this.trainingLessonList.length > 0)
        // {
        //   this.showLessonList = true;
        // }else{
        //   this.showLessonList = true;
        // }
        //
        this.loadingDone = true;
      } catch (e) {}
    });

    return subject.asObservable();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.lessonSelectedList);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.lessonSelectedList);
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
